<template>
  <v-theme-provider dark>
    <base-section
      id="info-alt"
      class="grey darken-4"
    >
      <v-responsive
        class="mx-auto"
        max-width="1400"
      >
        <v-container fluid>
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <base-info />
            </v-col>

            <v-col
              cols="12"
              md="5"
            >
              <base-info-card title="Contact" />

              <base-business-contact dense />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <info-features />
            </v-col>
          </v-row>
        </v-container>
      </v-responsive>
    </base-section>
      <base-img
        :src="require('@/assets/csr.png')"
        style="filter: brightness(0) invert(1)"
        width="100px"
      />
      <a class="white--text" outlined href="https://lk.kenwynconsultancy.com/coporate-social-responsibility">
        <b> Corporate Social Responsibility</b>
      </a>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionBusinessInfo',

    components: {
      InfoFeatures: () => import('@/components/InfoFeatures'),
    },
  }
</script>

<style lang="sass">
  #info-alt a
    text-decoration: none
</style>
